module.exports = __webpack_public_path__ + "img/file-plus-fill.1d5717c2.svg";